import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface FAQItem {
    _id?: string;
    question: string;
    answer: string;
}

export interface FAQGroup {
    _id?: string;
    title: string;
    faqs: FAQItem[];
    collapsed?: boolean;
    isEditingTitle?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class FaqService {
    private baseUrl = `${environment.baseUrl}properties-faq`;

    constructor(private http: HttpClient) { }

    // GET all groups for a property
    getGroups(propertyId: string): Observable<FAQGroup[]> {
        return this.http.get<FAQGroup[]>(`${this.baseUrl}/groups/${propertyId}`);
    }

    // CREATE new group
    createGroup(propertyId: string, title: string): Observable<FAQGroup> {
        return this.http.post<FAQGroup>(`${this.baseUrl}/group`, { propertyId, title });
    }

    // UPDATE group title
    updateGroupTitle(groupId: string, title: string): Observable<FAQGroup> {
        return this.http.patch<FAQGroup>(`${this.baseUrl}/group/${groupId}/title`, { title });
    }

    // ADD FAQ item
    addFaqItem(groupId: string, question: string, answer: string): Observable<FAQGroup> {
        return this.http.post<FAQGroup>(`${this.baseUrl}/group/${groupId}/item`, { question, answer });
    }

    // UPDATE FAQ item
    updateFaqItem(groupId: string, itemId: string, question: string, answer: string): Observable<FAQGroup> {
        return this.http.patch<FAQGroup>(`${this.baseUrl}/group/${groupId}/item/${itemId}`, { question, answer });
    }

    // DELETE FAQ item
    deleteFaqItem(groupId: string, itemId: string): Observable<FAQGroup> {
        return this.http.delete<FAQGroup>(`${this.baseUrl}/group/${groupId}/item/${itemId}`);
    }

    // DELETE group
    deleteGroup(groupId: string): Observable<any> {
        return this.http.delete(`${this.baseUrl}/group/${groupId}`);
    }

    createOrUpdateFaqs(groupId: string, payload: { title: string; faqs: FAQItem[] }): Observable<FAQGroup> {
        return this.http.post<FAQGroup>(`${this.baseUrl}/group/${groupId}/items`, { payload });
    }

    softDeleteGroup(groupId: string): Observable<any> {
        return this.http.delete(`${this.baseUrl}/group/${groupId}`);
    }
}